<script>
  import { onMount, onDestroy, tick } from 'svelte'
  import { config } from '../../scripts/defaultURL'
  import { getData } from '../../scripts/rest'
  import L from 'leaflet'

  let metrics = {
    totals: { total_clients: 0, total_scans: 0 },
    locations: [],
    scanTypes: []
  }
  let map
  let markerLayerGroup
  let missingCitiesList = []; 

  // COMPLETE REGISTRY: All missing cities from your directory have been added here
  const cityCoordinates = {
    // --- Original Base Registry ---
    Atlanta: [33.749, -84.388],
    Savannah: [32.0809, -81.0912],
    Birmingham: [33.5186, -86.8104],
    Montgomery: [32.3792, -86.3077],
    Nashville: [36.1627, -86.7816],
    Charlotte: [35.2271, -80.8431],
    Orlando: [28.5384, -81.3789],
    Huntsville: [34.7304, -86.5861],
    Madison: [34.6993, -86.7483],
    Athens: [34.8018, -86.9717],
    'Owens Cross Roads': [34.5868, -86.4597],
    "Owen's Cross Roads": [34.5868, -86.4597], // Catching apostrophe variation
    Cullman: [34.1748, -86.8436],
    Decatur: [34.6059, -86.9833],
    Guntersville: [34.3581, -86.2947],
    Gunterville: [34.3581, -86.2947], // Catching typo variant
    Harvest: [34.8529, -86.7483],
    Meridianville: [34.8565, -86.5722],
    Beira: [-19.8333, 34.8500],

    // --- Alabama Additions ---
    Hartselle: [34.4432, -86.9317],
    Hoover: [33.4054, -86.8114],
    'New Market': [34.9059, -86.4292],
    Scottsboro: [34.6723, -86.0341],
    Sulligent: [33.8984, -88.1334],
    Elkmont: [34.9304, -86.9772],
    Florence: [34.7998, -87.6773],
    'Hazel Green': [34.9329, -86.5758],
    Toney: [34.8995, -86.7511],
    Vernon: [33.7554, -88.1128],
    'Lacey Springs': [34.5345, -86.6067],
    Vinemont: [34.2415, -86.8664],
    Binemont: [34.2415, -86.8664], // Catching 'B' typo variant
    Albertville: [34.2676, -86.2089],
    Arab: [34.3181, -86.4958],
    Daphne: [30.6035, -87.9036],
    Gurley: [34.7018, -86.3917],
    Hollytree: [34.7984, -86.2505],
    Joppa: [34.2981, -86.5569],
    Langston: [34.5334, -86.0825],
    Mentone: [34.5843, -85.5911],
    Moulton: [34.4818, -87.2895],
    Somerville: [34.4745, -86.7975],
    Trinity: [34.6437, -87.085],
    'Union Grove': [34.4023, -86.6111],
    Winfield: [33.9312, -87.8109],
    Addison: [34.2007, -87.1789],
    'Alexander Rd': [34.6705, -86.7645], // Mapped to local road coordinates context if applicable
    Anderson: [34.9215, -87.5117],
    Ardmore: [34.9912, -86.8453],
    Blountsville: [34.0823, -86.5905],
    Brownsboro: [34.7506, -86.4344],
    Campbell: [31.9168, -88.0125],
    Centre: [34.1531, -85.6758],
    Columbiana: [33.1779, -86.6075],
    Detroit: [34.0284, -88.1728],
    Docena: [33.5498, -86.9272],
    Falkville: [34.3729, -86.9044],
    Fayetteville: [33.1554, -86.4172],
    Foley: [30.4066, -87.6836],
    'Fort Payne': [34.4426, -85.7225],
    Gardendale: [33.6598, -86.8128],
    Grant: [34.5298, -86.2519],
    'Hampton Cove': [34.6565, -86.4864],
    Hanceville: [34.0607, -86.7675],
    Hayden: [33.8943, -86.7589],
    Henager: [34.4645, -85.6883],
    Homewood: [33.4798, -86.8028],
    Hytop: [34.9123, -86.0867],
    Jasper: [33.8323, -87.2775],
    Killen: [34.8648, -87.5256],
    Logan: [34.1376, -86.9944],
    Oakman: [33.7126, -87.385],
    'Pell City': [33.5862, -86.2861],
    'Phil Campbell': [34.354, -87.7086],
    Pinson: [33.6893, -86.6833],
    Remlap: [33.8168, -86.5989],
    'Spruce Pine': [34.4018, -87.7373],
    Thorsby: [32.9168, -86.7175],
    'Town Creek': [34.6798, -87.4086],
    Trussville: [33.6198, -86.6089],
    Tuscaloosa: [33.2098, -87.5692],
    Vahlermoso: [34.484, -86.6997], // Variant catching 
    Valhermoso: [34.484, -86.6997], // Standard Valhermoso Springs
    Vestavia: [33.4487, -86.7878],
    'Vestavia Hills': [33.4487, -86.7878],

    // --- Out of State Additions ---
    Bush: [30.6124, -89.9015], // Louisiana
    Deridder: [30.8466, -93.2891], // Louisiana
    Burnsville: [34.8384, -88.3189], // Mississippi
    Brandon: [32.2732, -89.9859], // Mississippi
    Luka: [34.8118, -88.1906], // Iuka, MS variant typo correction tracking
    Iuka: [34.8118, -88.1906],
    Tishimingo: [34.6368, -88.2334], // Tishomingo, MS
    Tishomingo: [34.6368, -88.2334],
    Cookeville: [36.1628, -85.5016], // Tennessee
    Cornersville: [35.3576, -86.8428], // Tennessee
    Counce: [35.0518, -88.2536], // Tennessee
    Flintville: [35.0184, -86.4439], // Tennessee
    Grimsley: [36.2165, -84.9755], // Tennessee
    Lebanon: [36.2081, -86.2911], // Tennessee
    Lewisburg: [35.4492, -86.7892], // Tennessee
    Prospect: [35.0151, -86.9358], // Tennessee
    Pulaski: [35.1979, -87.0322] // Tennessee
  }

  const stateMap = {
    Alabama: 'AL', Alaska: 'AK', Arizona: 'AZ', Arkansas: 'AR', California: 'CA',
    Colorado: 'CO', Connecticut: 'CT', Delaware: 'DE', Florida: 'FL', Georgia: 'GA',
    Hawaii: 'HI', Idaho: 'ID', Illinois: 'IL', Indiana: 'IN', Iowa: 'IA',
    Kansas: 'KS', Kentucky: 'KY', Louisiana: 'LA', Maine: 'ME', Maryland: 'MD',
    Massachusetts: 'MA', Michigan: 'MI', Minnesota: 'MN', Mississippi: 'MS', Missouri: 'MO',
    Montana: 'MT', Nebraska: 'NE', Nevada: 'NV', 'New Hampshire': 'NH', 'New Jersey': 'NJ',
    'New Mexico': 'NM', 'New York': 'NY', 'North Carolina': 'NC', 'North Dakota': 'ND', Ohio: 'OH',
    Oklahoma: 'OK', Oregon: 'OR', Pennsylvania: 'PA', 'Rhode Island': 'RI', 'South Carolina': 'SC',
    'South Dakota': 'SD', Tennessee: 'TN', Texas: 'TX', Utah: 'UT', Vermont: 'VT',
    Virginia: 'VA', Washington: 'WA', 'West Virginia': 'WV', Wisconsin: 'WI', Wyoming: 'WY',
  }

  onMount(async () => {
    if (!document.getElementById('leaflet-base-css')) {
      const link = document.createElement('link')
      link.id = 'leaflet-base-css'
      link.rel = 'stylesheet'
      link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css'
      document.head.appendChild(link)
    }

    await tick()

    const mapElement = document.getElementById('map')
    if (!mapElement) return

    // Centered cleanly around North Alabama/Tennessee border cluster region area
    map = L.map('map').setView([34.55, -86.6], 9) 

    L.tileLayer(
      'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
      {
        attribution: '© OpenStreetMap contributors © CARTO',
        subdomains: 'abcd',
        maxZoom: 20,
      }
    ).addTo(map)

    markerLayerGroup = L.layerGroup().addTo(map)

    setTimeout(() => {
      if (map) map.removeControl(map.zoomControl);
      L.control.zoom({ position: 'topleft' }).addTo(map);
      if (map) map.invalidateSize()
    }, 200)

    try {
      const res = await getData(`${config.defaultURL}/metrics`)
      metrics = res

      const locationsData = res?.locations || []
      const tempMarkers = []
      let missingLocalTrack = [] 

      locationsData.forEach((loc) => {
        if (!loc.city || loc.city === '—' || loc.city === '') return

        const cleanCityName = loc.city.trim()
        
        let formattedCityName = cleanCityName
        if (!cleanCityName.includes(' ')) {
          formattedCityName = cleanCityName.charAt(0).toUpperCase() + cleanCityName.slice(1).toLowerCase()
        }

        // Check our expanded dictionary using both standard naming and direct raw inputs
        const coords = cityCoordinates[formattedCityName] || cityCoordinates[cleanCityName]

        if (coords) {
          const count = Number(loc.client_count || loc.clientCount || 0)
          const pinSize = Math.min(24 + count * 0.5, 60)

          let pinColor = '#00d1b2' 
          if (count >= 50) {
            pinColor = '#ff3860' 
          } else if (count >= 20) {
            pinColor = '#3273dc' 
          }

          const customIcon = L.divIcon({
            className: 'custom-marker-wrapper', 
            html: `
              <div style="
                background-color: ${pinColor}; 
                width: ${pinSize}px; 
                height: ${pinSize}px; 
                border-radius: 50%; 
                border: 2px solid white; 
                box-shadow: 0 2px 8px rgba(0,0,0,0.4);
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                text-align: center !important;
                line-height: ${pinSize - 4}px !important; /* Forces line boundary constraints */
                color: white;
                font-weight: bold;
                font-size: ${pinSize > 30 ? '12px' : '10px'};
              ">
                ${count}
              </div>
            `,
            iconSize: [pinSize, pinSize],
            iconAnchor: [pinSize / 2, pinSize / 2], 
          })

          const marker = L.marker(coords, { icon: customIcon })
          
          marker.bindPopup(`
            <strong>${formattedCityName}, ${formatState(loc.state)}</strong><br/>
            Active Clients: <strong>${count}</strong>
          `)

          tempMarkers.push(marker)
        } else {
          if (!missingLocalTrack.includes(loc.city.trim())) {
            missingLocalTrack.push(loc.city.trim());
          }
        }
      })

      missingCitiesList = missingLocalTrack;
      tempMarkers.forEach(m => markerLayerGroup.addLayer(m))

      // The automated downloader will now only fire if new entries arrive outside this lookup list
      if (missingLocalTrack.length > 0) {
        const fileContent = "UNMAPPED CITIES DIRECTORY:\n\n" + missingLocalTrack.join('\n');
        const blob = new Blob([fileContent], { type: 'text/plain' });
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = 'missing_map_cities.txt';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }

    } catch (e) {
      console.error('Failed to load metrics metadata or place pins', e)
    }
  })

  onDestroy(() => {
    if (map) map.remove()
  })

  function formatState(state) {
    if (!state) return '—'
    if (state.length === 2) return state.toUpperCase()
    return stateMap[state] || state
  }
</script>

<section>
  <h3>Business Metrics</h3>
</section>

<div class="map-card card">
  <h4>Customer Geographics</h4>
  <div id="map"></div>

  {#if missingCitiesList.length > 0}
    <div style="margin-top: 1rem; border-top: 2px dashed #ff3860; padding-top: 1rem;">
      <h4 style="color: #ff3860; margin-bottom: 0.25rem;">⚠️ Missing Coordinates Registry Lookup ({missingCitiesList.length})</h4>
      <p style="font-size: 0.85rem; color: #666; margin-bottom: 0.5rem;">
        Copy these values directly to find their Lat/Long values and expand your cityCoordinates registry:
      </p>
      <textarea 
        readonly 
        style="width: 100%; height: 120px; font-family: monospace; font-size: 13px; padding: 10px; border-radius: 6px; border: 1px solid #ff3860; background-color: #fffafb; color: #333;"
        value={missingCitiesList.join('\n')}
      ></textarea>
    </div>
  {/if}
</div>

<div class="metrics-grid">
  <div class="card">
    <h4>Overview</h4>
    <p><strong>Total Clients:</strong> {metrics.totals.total_clients}</p>
    <p><strong>Total Scans:</strong> {metrics.totals.total_scans}</p>
  </div>

  <div class="card">
    <h4>Clients by Location</h4>
    <table class="svelte-table">
      <thead>
        <tr>
          <th>State</th>
          <th>City</th>
          <th>Clients</th>
        </tr>
      </thead>
      <tbody>
        {#each metrics.locations as loc}
          <tr>
            <td>{formatState(loc.state) || '—'}</td>
            <td>{loc.city || '—'}</td>
            <td><strong>{loc.client_count}</strong></td>
          </tr>
        {/each}
      </tbody>
    </table>
  </div>

  <div class="card">
    <h4>Scans by Type</h4>
    <table class="svelte-table">
      <thead>
        <tr>
          <th>Scan Type</th>
          <th>Count</th>
          <th>Total Income</th>
        </tr>
      </thead>
      <tbody>
        {#each metrics.scanTypes as scan}
          <tr>
            <td>{scan.type || '—'}</td>
            <td><strong>{scan.scan_count}</strong></td>
            <td><strong>${Number(scan.total_income || 0).toLocaleString()}</strong></td>
          </tr>
        {/each}
      </tbody>
    </table>
  </div>
</div>

<style>
  .map-card {
    margin-bottom: 1.5rem;
    width: 100%;
  }

  #map {
    height: 400px !important;
    width: 100% !important;
    border-radius: 6px;
    z-index: 1;
    background-color: #f5f5f5;
    position: relative;
    overflow: hidden;
  }

  #map :global(.leaflet-pane) {
    z-index: 10 !important; /* Bump up overall pane layout base */
  }
  #map :global(.leaflet-tile-pane) {
    z-index: 1 !important; /* Lock background tiles down low */
  }
  #map :global(.leaflet-marker-pane) {
    z-index: 999 !important; /* Force Leaflet's native marker layer container to stay explicitly on top */
  }
  #map :global(.leaflet-popup-pane) {
    z-index: 1000 !important; /* FIX: Tooltips render on top of pins */
  }
  #map :global(.leaflet-tile-container) {
    display: block !important;
  }
  #map :global(.custom-map-pin) {
    background: transparent !important;
    border: none !important;
  }

  .metrics-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 1.5rem;
    margin-top: 1rem;
  }
  .card {
    background: white;
    padding: 1.5rem;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }
  th, td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #eee;
  }
  th {
    background: #f5f5f5;
  }

  #map :global(.custom-marker-wrapper) {
    background: transparent !important;
    border: none !important;
    margin: 0 !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center;
    justify-content: center;
    overflow: visible !important;
  }
</style>